import Box from "@material-ui/core/esm/Box";
import Radio from "@material-ui/core/esm/Radio";
import RadioGroup from "@material-ui/core/esm/RadioGroup";
import FormControl from "@material-ui/core/esm/FormControl";
import FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import { nanoid } from 'nanoid';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoBox from 'components/InfoBox/InfoBox';
import { BoldSubtitle } from 'components/Text';
import tagOptions from 'constants/tagOptions';
import useUnregisterVehicle from 'hooks/vehicles/unregister/useUnregisterVehicle';
import useStyles from './TagOptionsStyles';
export default function ChooseTagOption() {
  const {
    t
  } = useTranslation();
  const {
    chooseTagRoot,
    radio,
    checked
  } = useStyles();
  const {
    currentTagOption,
    setCurrentTagOption,
    currentVehicle
  } = useUnregisterVehicle();
  const isFrozen = currentVehicle?.obeStatus === 'Frozen';
  const chooseTagOptionId = `select tag option ${nanoid()}`;
  const handleRadioGroupChange = event => {
    const {
      value
    } = event.target;
    setCurrentTagOption(value === tagOptions.KEEP_AND_REUSE ? tagOptions.KEEP_AND_REUSE : tagOptions.THROW_AND_RECEIVE_DEPOSIT);
  };
  return /*#__PURE__*/React.createElement(Box, {
    my: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: chooseTagRoot
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    htmlFor: chooseTagOptionId
  }, t('unregister_vehicle.tag_options_title')), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(Box, {
    my: 1
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    id: chooseTagOptionId,
    name: "TagOption",
    value: currentTagOption,
    onChange: handleRadioGroupChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: tagOptions.KEEP_AND_REUSE,
    control: /*#__PURE__*/React.createElement(Radio, {
      classes: {
        root: radio,
        checked
      }
    }),
    label: t('unregister_vehicle.keep_and_reuse')
  }), !isFrozen && /*#__PURE__*/React.createElement(FormControlLabel, {
    value: tagOptions.THROW_AND_RECEIVE_DEPOSIT,
    control: /*#__PURE__*/React.createElement(Radio, {
      classes: {
        root: radio,
        checked
      }
    }),
    label: t('unregister_vehicle.throw')
  }), isFrozen && /*#__PURE__*/React.createElement(InfoBox, {
    warning: true
  }, t('unregister_vehicle.frozen_warning')))))));
}